import { useEffect } from 'react'
import { useAuthStore } from '@/store/authStore'
import { useNotificationStore } from '@/store/notificationStore'

/**
 * Hook that manages notification subscription lifecycle.
 * Call once at app level (e.g., App.tsx) to set up the real-time subscription.
 * Subscribes when user logs in, unsubscribes on logout.
 */
export function useNotificationSubscription() {
  const user = useAuthStore((s) => s.user)
  const subscribe = useNotificationStore((s) => s.subscribe)
  const unsubscribe = useNotificationStore((s) => s.unsubscribe)

  useEffect(() => {
    if (!user) {
      unsubscribe()
      return
    }

    subscribe(user.uid)

    return () => {
      unsubscribe()
    }
  }, [user?.uid])
}
